interface UserTokenData {
  userName: string;
  id: string;
  email: string;
  role: string;
}

//TODO for Hamdan and Himanshu
// -need to check  the current method of implementation for our JWT tokens with the data in them, such as role, is correct and could in fact be a major security flaw.
export class UserUtils {
  /**
   * Decodes the JWT token to extract user information
   * @param token - The JWT token string
   * @returns UserTokenData or null if invalid
   */
  static decodeUserToken(token: string): UserTokenData | null {
    try {
      // JWT tokens have 3 parts separated by dots
      const parts = token.split('.');
      if (parts.length !== 3) {
        return null;
      }

      // The payload is the middle part (index 1)
      const payload = parts[1];

      // Decode base64 URL (replace - with + and _ with /)
      const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');

      // Decode and parse JSON
      const decoded = JSON.parse(atob(base64));

      return {
        userName: decoded.userName,
        id: decoded.id,
        email: decoded.email,
        role: decoded.role,
      };
    } catch (error) {
      console.error('Error decoding token:', error);
      return null;
    }
  }

  /**
   * Gets the current user's information from the stored token
   * @returns UserTokenData or null if no valid token
   */
  static getCurrentUser(): UserTokenData | null {
    const token = localStorage.getItem('token');
    if (!token) {
      return null;
    }

    return this.decodeUserToken(token);
  }

  /**
   * Gets the current user's name from the stored token
   * @returns string username or 'User' as fallback
   */
  static getCurrentUserName(): string {
    const user = this.getCurrentUser();
    return user?.userName || 'User';
  }
}
